import { render } from "./TableIcp.vue?vue&type=template&id=78548160&scoped=true"
import script from "./TableIcp.vue?vue&type=script&lang=js"
export * from "./TableIcp.vue?vue&type=script&lang=js"

import "./TableIcp.vue?vue&type=style&index=0&id=78548160&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78548160"]])

export default __exports__